import React from 'react';
import PropTypes from 'prop-types';

export default function BoldText({ copy1, emphasise, copy2 }) {
  return (
    <span>
      {copy1} <span className="fontWeight-6">{emphasise}</span> {copy2}
    </span>
  );
}

BoldText.propTypes = {
  copy1: PropTypes.string,
  emphasise: PropTypes.string,
  copy2: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/commons/BoldText/index.js